import { render } from "./PlatFormVideoCate.vue?vue&type=template&id=170a3a30&scoped=true"
import script from "./PlatFormVideoCate.vue?vue&type=script&lang=js"
export * from "./PlatFormVideoCate.vue?vue&type=script&lang=js"

import "./PlatFormVideoCate.vue?vue&type=style&index=0&id=170a3a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170a3a30"]])

export default __exports__